export default {
  visibilityButtonTitle: 'Changer la visibilité du mot de passe',
};
